import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { styled } from "styled-components";
import theme from "../../../styles/theme";
import { useEffect, useState } from "react";
import moment from "moment";

const MainWrap = styled.div`
    height: 100%;
    width: 100%;
    background: ${theme.color.white[100]};
    border-radius: 12px;
    padding: 0.5rem 1rem;
    .title {
        font-size: 1.25rem;
    }
`;

const DescArea = styled.ul`
    list-style-type: none;
    padding:0;
    margin:0;
    li {
        height: 3.25rem;
        line-height: 2rem;
        font-size: 1.2rem;
        display: flex;
        span {
            display: flex;
            align-items: center;
            width: 120px;
            padding-left: 4px;
            border-bottom:1px solid ${theme.color.black[20]};
        }
        span:nth-child(1){
            width: 240px;
        }
        span:nth-child(2), span:nth-child(3), span:nth-child(5){
            width: 75px;
            text-align: center;
        }
        span:nth-child(5){
            width:120px;
        }
    }
    li:first-child {
        font-size: 1rem;
        height: 2.2rem;
    }
    li:nth-child(even) {
        background: ${theme.color.primary.pupple};
    }
    li:last-child {
        border: 0px;
        span {
            border-bottom:0;
        }
    }
    .titleEl {
        // width: 40%;
        // display: block;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
`;

const DateArea = styled.ul`
    list-style-type: none;
    padding:0;
    margin:0;
    li {
        height: 3.25rem;
        line-height: 2rem;
        font-size: 1.2rem;
        display: grid;
        grid-template-columns: repeat(21, 1fr);
        div {
            display: block;
            min-width:30px;
            text-align: center;
            border-bottom:1px solid ${theme.color.black[20]};
        }
    }
    li:first-child {
        font-size: 1rem;
        height: 2.2rem;
    }
    // li:nth-child(even) {
    //     background: ${theme.color.primary.pupple};
    // }
    li:last-child {
        border: 0px;
        div {
            border-bottom:0;
        }
    }
`;

const sampleData = [
    {
        title:'파주운정3택지개발지구 6개소(유턴포함)',
        point_cnt: 2,
        camera_cnt: 4,
        camera_cnt: 4,
        pro_st:'Q',
        client_nm: '가나다라마바사아',
        set_person: ['민준식','이동규'],
        req_from: '2023-10-12',
        req_to: '2023-10-13',
        set_from: '2023-10-15',
        set_to: '2023-10-16',
        rec_from: '2023-10-15',
        rec_to: '2023-10-17',
        coding_from: '2023-10-20',
        coding_to: '2023-10-21',
        odate:'2023-10-23'
    },
    {
        title:'2222 6개소(유턴포함)',
        point_cnt: 2,
        camera_cnt: 4,
        pro_st:'R',
        client_nm: '가나다아',
        set_person: ['민준식'],
        req_from: '2023-10-11',
        req_to: '2023-10-11',
        set_from: '2023-10-14',
        set_to: '2023-10-14',
        rec_from: '2023-10-15',
        rec_to: '2023-10-17',
        coding_from: '2023-10-20',
        coding_to: '2023-10-21',
        odate:'2023-10-23'
    },
    {
        title:'33333 6개소(유턴포함)',
        point_cnt: 2,
        camera_cnt: 4,
        pro_st:'I',
        client_nm: '가나다아',
        set_person: ['민준식'],
        req_from: '2023-10-11',
        req_to: '2023-10-11',
        set_from: '2023-10-14',
        set_to: '2023-10-14',
        rec_from: '2023-10-15',
        rec_to: '2023-10-17',
        coding_from: '2023-10-20',
        coding_to: '2023-10-21',
        odate:'2023-10-23'
    },
    {
        title:'4444 6개소(유턴포함)',
        point_cnt: 2,
        camera_cnt: 4,
        pro_st:'I',
        client_nm: '가나다아',
        set_person: ['민준식'],
        req_from: '2023-10-11',
        req_to: '2023-10-11',
        set_from: '2023-10-14',
        set_to: '2023-10-14',
        rec_from: '2023-10-15',
        rec_to: '2023-10-17',
        coding_from: '2023-10-20',
        coding_to: '2023-10-21',
        odate:'2023-10-23'
    },
    {
        title:'5555 6개소(유턴포함)',
        point_cnt: 2,
        camera_cnt: 4,
        pro_st:'S',
        client_nm: '가나다아',
        set_person: ['민준식'],
        req_from: '2023-10-11',
        req_to: '2023-10-11',
        set_from: '2023-10-14',
        set_to: '2023-10-14',
        rec_from: '2023-10-15',
        rec_to: '2023-10-17',
        coding_from: '2023-10-18',
        coding_to: '2023-10-20',
        odate:'2023-10-23'
    },
    {
        title:'6666 6개소(유턴포함)',
        point_cnt: 2,
        camera_cnt: 4,
        pro_st:'S',
        client_nm: '가나다아',
        set_person: ['민준식'],
        req_from: '2023-10-13',
        req_to: '2023-10-13',
        set_from: '2023-10-16',
        set_to: '2023-10-16',
        rec_from: '2023-10-17',
        rec_to: '2023-10-19',
        coding_from: '2023-10-19',
        coding_to: '2023-10-21',
        odate:'2023-10-23'
    },
    {
        title:'7777 6개소(유턴포함)',
        point_cnt: 2,
        camera_cnt: 4,
        pro_st:'E',
        client_nm: '가나다아',
        set_person: ['민준식'],
        req_from: '2023-10-11',
        req_to: '2023-10-11',
        set_from: '2023-10-14',
        set_to: '2023-10-14',
        rec_from: '2023-10-15',
        rec_to: '2023-10-17',
        coding_from: '2023-10-20',
        coding_to: '2023-10-21',
        odate:'2023-10-23'
    },
    {
        title:'8888888 6개소(유턴포함)',
        point_cnt: 2,
        camera_cnt: 4,
        pro_st:'E',
        client_nm: '가나다아',
        set_person: ['민준식'],
        req_from: '2023-09-11',
        req_to: '2023-09-11',
        set_from: '2023-09-14',
        set_to: '2023-09-14',
        rec_from: '2023-09-15',
        rec_to: '2023-09-17',
        coding_from: '2023-09-20',
        coding_to: '2023-09-21',
        odate:'2023-09-23'
    },
    {
        title:'99999999 6개소(유턴포함)',
        point_cnt: 2,
        camera_cnt: 4,
        pro_st:'E',
        client_nm: '가나다아',
        set_person: ['민준식'],
        req_from: '2023-09-16',
        req_to: '2023-09-16',
        set_from: '2023-09-19',
        set_to: '2023-09-19',
        rec_from: '2023-09-20',
        rec_to: '2023-09-23',
        coding_from: '2023-09-25',
        coding_to: '2023-09-26',
        odate:'2023-09-27'
    },
    // {
    //     title:'00 6개소(유턴포함)',
    //     point_cnt: 2,
    //     camera_cnt: 4,
    //     pro_st:'E',
    //     client_nm: '가나다아',
    //     set_person: ['민준식'],
    //     req_from: '2023-09-19',
    //     req_to: '2023-09-19',
    //     set_from: '2023-09-24',
    //     set_to: '2023-09-24',
    //     rec_from: '2023-09-28',
    //     rec_to: '2023-09-30',
    //     coding_from: '2023-10-01',
    //     coding_to: '2023-10-04',
    //     odate:'2023-10-06'
    // },
    // {
    //     title:'11/11/11/11/11/ 6개소(유턴포함)',
    //     point_cnt: 2,
    //     camera_cnt: 4,
    //     client_nm: '가나다아',
    //     set_person: ['민준식'],
    //     req_from: '2023-09-20',
    //     req_to: '2023-09-20',
    //     set_from: '2023-09-24',
    //     set_to: '2023-09-24',
    //     rec_from: '2023-09-28',
    //     rec_to: '2023-09-30',
    //     coding_from: '2023-10-01',
    //     coding_to: '2023-10-04',
    //     odate:'2023-10-06'
    // },
    // {
    //     title:'12/12/12/12/12/12/12/ 6개소(유턴포함)',
    //     point_cnt: 2,
    //     camera_cnt: 4,
    //     client_nm: '가나다아',
    //     set_person: ['민준식'],
    //     req_from: '2023-09-21',
    //     req_to: '2023-09-21',
    //     set_from: '2023-09-24',
    //     set_to: '2023-09-24',
    //     rec_from: '2023-09-28',
    //     rec_to: '2023-09-30',
    //     coding_from: '2023-10-01',
    //     coding_to: '2023-10-04',
    //     odate:'2023-10-06'
    // }
]

const Schedule = () => {

    const [dateArray, setDateArray] = useState();
    const [list, setList] = useState();

    useEffect(()=>{
        const from = moment().day(-7);
        const temp  = Array(21).fill().map(()=>from.add(1,'days').format('yyyy-MM-DD'));
        setDateArray(temp);
        setList(sampleData);
    },[])

    return (
            <div style={{display:'grid',gridTemplateColumns:'600px auto'}}>
                <DescArea>
                    <li>
                        <span>과업명</span>
                        <span>지점수</span>
                        <span>카메라</span>
                        <span style={{textAlign:'center'}}>발주처</span>
                        <span>설치자</span>
                    </li>
                    {list && list.map((item,index)=>
                        <li key={index}>
                            <span className="titleEl">{item.title}</span>
                            <span>{item.point_cnt}</span>
                            <span>{item.camera_cnt}</span>
                            <span className="titleEl">{item.client_nm}</span>
                            <span>
                                {item.set_person && item.set_person.map((item,index)=> index>0? ','+item : item)}
                            </span>
                        </li>
                    )}
                </DescArea>
                <DateArea style={{overflowY:'hidden',overflowX:'scroll'}}> 
                    <li>
                        {dateArray && dateArray.map((item,index)=>{
                            let border = `1px solid ${theme.color.black[20]}`;
                            let borderTop = `0`;
                            if(item === moment().format('yyyy-MM-DD') || item === moment().add(1,'days').format('yyyy-MM-DD')){
                                border = `2px solid red`;
                            }
                            if(item === moment().format('yyyy-MM-DD')){
                                borderTop = `2px solid red`;
                            }
                            return <div key={index} style={{borderLeft: border,borderTop:borderTop}}>{item.substr(item.length-2,item.length)}</div>
                        })}
                    </li>
                    {list && list.map((item,index)=>
                        <li key={index}>
                            {dateArray && dateArray.map((dItem,dIndex)=>{
                                let targetColor = theme.color.white[100];
                                let border = `1px solid ${theme.color.black[20]}`;
                                let borderBottom = `1px solid ${theme.color.black[20]}`;
                                if(dItem === moment().format('yyyy-MM-DD') || dItem === moment().add(1,'days').format('yyyy-MM-DD')){
                                    border = `2px solid red`;
                                }
                                if(index === (list.length - 1)){
                                    if(dItem === moment().format('yyyy-MM-DD')){
                                        borderBottom = `2px solid red`;
                                    }else{
                                        borderBottom = `0`;
                                    }
                                }
                                if(moment(dItem).isBetween(item.req_from,item.req_to,undefined,'[]')){
                                    targetColor = theme.color.primary.blue;
                                }
                                if(moment(dItem).isBetween(item.set_from,item.set_to,undefined,'[]')){
                                    targetColor = theme.color.secondary.puppleA;
                                }
                                if(moment(dItem).isBetween(item.rec_from,item.rec_to,undefined,'[]')){
                                    targetColor = theme.color.secondary.puppleB;
                                }
                                if(moment(dItem).isBetween(item.coding_from,item.coding_to,undefined,'[]')){
                                    targetColor = theme.color.secondary.yellow;
                                }
                                if(dItem===item.odate){
                                    targetColor = theme.color.primary.pupple;
                                }
                                return <div 
                                    key={dIndex} 
                                    style={{display:'flex',alignItems:'center',borderLeft: border,borderBottom}}
                                >
                                    <span style={{display:'block',width:'100%',height:'1.3rem', background: targetColor}}></span>
                                </div>
                            })}
                        </li>
                    )}
                </DateArea>

            </div>
    )

}

export default Schedule